import { forwardRef } from 'react';

import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

const ResponsiveLogo = ({ showIcon, sx }) => {
  const isSmallScreen = useMediaQuery('(max-width:200px)'); // 'sm' breakpoint
  const isMediumScreen = useMediaQuery('(min-width:200px) and (max-width:960px)'); // 'md' breakpoint
  const isLargeScreen = useMediaQuery('(min-width:960px)'); // 'lg' breakpoint

  let imageSrc;
  let width;

  if (isMediumScreen || isSmallScreen || showIcon) {
    imageSrc = '/logo/bread-logo-sm.svg';
    width = 40;
    // } else if (isMediumScreen) {
    //   imageSrc = '/logo/bread-logo-md.svg';
    //   width = 128;
  } else if (isLargeScreen) {
    imageSrc = '/logo/bread-logo-full.svg';
    width = 212;
  }

  return (
    <Box component="img" src={imageSrc} sx={{ width, height: 40, cursor: 'pointer', ...sx }} />
  );
};

const Logo = forwardRef(({ showIcon = false, disabledLink = false, sx, ...other }, ref) => {
  if (disabledLink) {
    return <ResponsiveLogo showIcon={showIcon} sx={{ ...sx }} />;
  }

  return (
    <Link component={RouterLink} href="/" sx={{ /* display: 'contents', */ ...sx }}>
      <ResponsiveLogo showIcon={showIcon} />
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
